<template>
  <v-app id="inspire">
    <v-navigation-drawer v-model="drawer">
        <NavContent />
      </v-navigation-drawer>
    <v-app-bar class="bg-blue-grey-darken-4">

      <v-app-bar-nav-icon @click="drawer = !drawer"></v-app-bar-nav-icon>
      <v-app-bar-title>Outlabel - Compras</v-app-bar-title>

      <v-spacer></v-spacer>
      
      <!-- Menu de usuário -->
      <v-menu
        v-model="userMenu"
        :close-on-content-click="false"
        location="bottom end"
        transition="scale-transition"
        min-width="200"
      >
        <template v-slot:activator="{ props }">
          <v-btn
            icon
            v-bind="props"
            class="mr-2"
          >
            <v-avatar color="error" size="small">
              <v-icon icon="mdi-account-circle"></v-icon>
            </v-avatar>
          </v-btn>
        </template>
        
        <v-card>
          <v-card-text class="pa-4">
            <div class="d-flex flex-column align-center">
            
              <div class="text-h6 mb-1">{{ userFullName }}</div>
              <div class="text-subtitle-2 text-grey mb-3">{{ userRole }}</div>
              
              <v-divider class="mb-3 w-100"></v-divider>
              
              <v-btn 
                variant="tonal"
                color="error"
                block
                @click="onLogout"
                class="mb-2"
              >
                <v-icon left>mdi-logout</v-icon>
                Logout
              </v-btn>
            </div>
          </v-card-text>
        </v-card>
      </v-menu>
    </v-app-bar>

    <v-main>
      <router-view />
    </v-main>
  </v-app>
</template>
<script>
import NavContent from '@/components/NavContent.vue';

import { mapState, mapActions, mapGetters } from 'vuex';

export default {
  name: 'MainView',

  components: {
    NavContent
  },

  data: () => ({ 
    drawer: null,
    userMenu: false,
  }),

  computed: {
    ...mapState('user', ['user']),
    ...mapGetters('user', ['userFullName']),

    userRole() {
      const roles = {
        'ADMIN': 'Administrador',
        'APPROVER': 'Aprovador',
        'FINANCE': 'Financeiro',
        'PURCHASE': 'Compras',
        'REQUESTER': 'Requisitante'
      };
      return this.user && this.user.role ? roles[this.user.role] || this.user.role : '';
    }
  },

  async mounted() {
    if (!Object.keys(this.user).length) {
      const { success } = await this.getUser();

      if (!success) {
        return this.$router.push({ name: 'SignPage' })
      } else {
        if (!this.user.access) {
          localStorage.removeItem('user');
          localStorage.removeItem('accessToken');

          return this.$router.push({ name: 'SignPage' })
        }

        return this.$router.push({ name: 'RequestView' })
      }
    }
  },

  methods: {
    ...mapActions('user', ['getUser', 'logout']),

    async onLogout() {
      const { success } = await this.logout();

      if (success) {
        this.$router.push({ name: 'SignPage'})
      }
    }
  }
}
</script>